import * as types from '../actions/action-types';
import initialState from './deliveryOptionInitialState';

export default function deliveryOptionReducer(state = initialState.deliveryOption, action) {
  switch (action.type) {
    case types.UPDATE_SELECTED_NAMED_DAY_INDEX: {
      const newGroups = [...state.deliveryGroups];
      const newGroup = {...newGroups[action.groupId]};
      const newOptions = [...newGroup.deliveryOptions];
      const newOption = {...newOptions[action.optionIndex]};
      
      newOption.selectedDeliverableDateIndex = action.selectedDeliverableDateIndex;
      newOptions[action.optionIndex] = newOption;
      newGroup.deliveryOptions = newOptions;
      newGroups[action.groupId] = newGroup;
  
      return {
        ...state,
        deliveryGroups: newGroups,
      };
    }
  
    case types.UPDATE_SELECTED_OPTION_INDEX: {
      const newState = {
        ...state,
        deliveryGroups: [...state.deliveryGroups],
      };
      newState.deliveryGroups[action.selectedOption.groupId] = {
        ...newState.deliveryGroups[action.selectedOption.groupId],
        selectedOptionIndex: action.selectedOption.selectedOptionIndex,
      };
      return newState;
    }
  
    case types.UPDATE_DELIVERY_OPTION_STATUS:
      return {...state, status: action.status};
  
    case types.ENABLE_PRODUCT_PREVIEW:
      return {...state, productPreview: action.productPreview};
  
    case types.DISABLE_PRODUCT_PREVIEW:
      return {...state, productPreview: action.productPreview};
  
    case types.UPDATE_FOCUS_ITEM:
      return {...state, focusItem: action.focusItem};

    case types.UPDATE_DELIVERY_OPTIONS:
      return {
        ...state,
        ...action.deliveryOptions,
      };
    
    case types.UPDATE_OPTIONAL_GROUP_USED: {
      const newState = {
        ...state,
        deliveryGroups: [...state.deliveryGroups],
      };
      newState.deliveryGroups[action.groupId] = {
        ...newState.deliveryGroups[action.groupId],
        used: action.used,
      };
      return newState;
    }
    
    case types.RESET_DELIVERY_OPTIONS:
      return initialState.deliveryOption;
  
    case types.UPDATE_DELIVERY_COUNTRY:
      return {
        ...state,
        deliveryCountryForDeliveryOptions: action.country,
      };
      
    default:
      return state;
  }
}
